<template>
    <div id="Statecake" style="width: 100%; height: 35%"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    shopInfo: {
      type: Object,
      default: ''
    }
  },
  data () {
    return {
      signinBeg: {
        fcCode: '',  //工厂
        shopCode: '',   //车间
        sectionCode: '',   //工段
        lineCode: ''
      },
      lineInfo: [],
    }
  },
  watch: {
    shopInfo: {
      handler (val) {
        this.signinBeg.fcCode = val.fcCode
        this.signinBeg.shopCode = val.shopCode
        this.signinBeg.sectionCode = val.sectionCode
        this.signinBeg.lineCode = val.lineCode
        this.lineState()
      },
      deep: true
    }
  },
  mounted () {
      if (window.sessionStorage.getItem('userInfo')) {
          let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
          if (userInfo.factoryId == 0) {
              this.lineState()
          }
      }
  },
  methods: {
    //产线状态
    lineState () {
      let options = {
        method: 'GET',
        url: this.$api.factorylineState,
        params: this.signinBeg
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.lineInfo = response.data
          this.stateCake()
        } else {
          this.$message.error('请求失败！')
        }
      })
    },
    //设备状态柱形图
    stateCake () {
      var self = this
      var chartDom = document.getElementById('Statecake')
      var myChart = echarts.init(chartDom)
      window.addEventListener('resize', () => {
        myChart.resize()
      })
      var option
      var xData = ['运行', '故障', '调试', '计划停机']
      var yData = [this.lineInfo.devInRunStatus, this.lineInfo.devInFaultStatus, this.lineInfo.devInIdleStatus, this.lineInfo.devInHaltStatus]
      option = {
        'grid': {
          'top': '17%',
          'left': '-5%',
          'bottom': '5%',
          'right': '5%',
          'containLabel': true
        },
        tooltip: {
          show: true
          //   trigger: 'axis',
          //   axisPointer: {
          //     type: 'shadow'
          //   },
          //   textStyle: {
          //     color: '#999',
          //     align: 'left'
          //   },
          //   position: ['30%', '30%'],
          //   extraCssText:
          //     'box-shadow:0px 0px 8px 0px rgba(176,176,176,1)',
          //   backgroundColor: '#fff',
          //   formatter: function (params) {
          //     console.log(params)
          //     //去除重复数据
          //     for (var i = 0;i < params.length;i++) {
          //       for (var j = params.length - 1;j > i;j--) {
          //         if (
          //           params[j].seriesName == params[i].seriesName
          //         ) {
          //           params.splice(j, 1)
          //           break
          //         }
          //       }
          //     }
          //     var res = ''
          //     console.log(params)
          //     var data = '<p>' + params[0].name + '</p >'
          //     res += '<p>' + params[0].value + '</p >'
          //     return data + res
          //   }
        },
        animation: false,
        'xAxis': [{
          'type': 'category',
          'data': xData,
          'axisTick': {
            'alignWithLabel': true
          },
          'nameTextStyle': {
            'color': '#82b0ec'
          },
          'axisLine': {
            show: false,
            'lineStyle': {
              'color': '#82b0ec'
            }
          },
          'axisLabel': {
            interval: 0,
            'textStyle': {
              'color': '#fff'
            },
            margin: 30
          }
        }],
        'yAxis': [{
          show: false,
          'type': 'value',
          'axisLabel': {
            interval: 0,
            'textStyle': {
              'color': '#fff'
            }
          },
          'splitLine': {
            'lineStyle': {
              'color': '#0c2c5a'
            }
          },
          'axisLine': {
            'show': false
          }
        }],
        'series': [{
          'name': '',
          type: 'pictorialBar',
          symbolSize: [20, 10],
          symbolOffset: [0, -6],
          symbolPosition: 'end',
          z: 12,
          // "barWidth": "0",
          'label': {
            'normal': {
              'show': true,
              'position': 'top',
              // "formatter": "{c}%"
              fontSize: 15,
              fontWeight: 'bold',
              color: '#5bfcf4'
            }
          },
          color: '#5bfcf4',
          data: yData
        },
        {
          name: '',
          type: 'pictorialBar',
          symbolSize: [20, 10],
          symbolOffset: [0, 7],
          // "barWidth": "20",
          z: 12,
          'color': '#5bfcf4',
          'data': yData
        },
        // {
        //   name: '',
        //   type: 'pictorialBar',
        //   symbolSize: [30, 15],
        //   symbolOffset: [0, 15],
        //   z: 10,
        //   itemStyle: {
        //     normal: {
        //       color: 'transparent',
        //       borderColor: '#ff2323',
        //       borderType: 'solid',
        //       borderWidth: 10
        //     }
        //   },
        //   data: yData
        // },
        // {
        //   name: '',
        //   type: 'pictorialBar',
        //   symbolSize: [40, 20],
        //   symbolOffset: [0, 18],
        //   z: 10,
        //   itemStyle: {
        //     normal: {
        //       color: 'transparent',
        //       borderColor: '#ff2323',
        //       borderType: 'solid',
        //       borderWidth: 8
        //     }
        //   },
        //   data: yData
        // },
        {
          type: 'bar',
          //silent: true,
          'barWidth': '20',
          barGap: '10%', // Make series be overlap
          barCateGoryGap: '10%',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = [
                  ['#2bbea3', '#0B3147'],
                  ['rgb(255, 0, 0)', '#0B3147'],
                  ['#c5ae76', '#0B3147'],
                  ['#b7b5bc', '#0B3147'],
                ]
                var index = params.dataIndex
                if (params.dataIndex >= colorList.length) {
                  index = params.dataIndex - colorList.length
                }
                return new echarts.graphic.LinearGradient(0, 0, 0, 1,
                  [{
                    offset: 0,
                    color: colorList[index][0]
                  },
                  {
                    offset: 1,
                    color: colorList[index][1]
                  }
                  ])
              },
              //   color: new echarts.graphic.LinearGradient(0, 0, 0, 0.7, [{
              //     offset: 0,
              //     color: '#38B2E6'
              //   },
              //   {
              //     offset: 1,
              //     color: '#0B3147'
              //   }
              //   ]),
              opacity: .8
            }
          },
          data: yData
        }
        ]
      }
      option && myChart.setOption(option)
    }
  }
}
</script>

<style>
</style>
